

import { create } from 'zustand';
// import { LocalStorageKeys } from '../constants/localStorage.js';

// export const lowPoolParamKeys = {
//   isShowLowAllPools: 'isShowLowAllPools',
//   isShowParticipantLowPools: 'isShowParticipantLowPools',
//   isShowCreatorLowPools: 'isShowCreatorLowPools',
// };

// const getInitialIsShowLowPools = field => {
//   const savedState = localStorage.getItem(field);

//   return savedState ? JSON.parse(savedState) : 'hide';
// };

// const getInitialTheme = () => {
//   return localStorage.getItem('darkmode') === 'true';
// };

export const appStore = create(set => ({
  isOpenedUserMenu: false,
  isFooterMenuOpened: false,
  setIsFooterMenuOpened: isFooterMenuOpened => set({ isFooterMenuOpened }),
  setIsOpenedUserMenu: isOpenedUserMenu => set({ isOpenedUserMenu }),
	walletAddress: undefined,
	setWalletAddress: walletAddress => set({ walletAddress}),
	
  isOpenedReceiveModal: false,
  setIsOpenedReceiveModal: isOpenedReceiveModal =>
    set({ isOpenedReceiveModal }),
  isOpenedSendModal: false,
  setIsOpenedSendModal: isOpenedSendModal => set({ isOpenedSendModal }),
  isMenuActive: false,
  setMenuActive: isMenuActive => set({ isMenuActive }),
  isBurgerOpened: false,
  setIsBurgerOpened: isBurgerOpened => set({ isBurgerOpened }),
  // darkmode: getInitialTheme(),
  // setDarkmode: darkmode => set({ darkmode }),
  // isWalletModalActive: false,
  // isNetworksModalActive: false,
  // openFooterModal: false,
  // setOpenFooterModal: openFooterModal => set({ openFooterModal }),
  // setWalletModalActive: isWalletModalActive => set({ isWalletModalActive }),
  // setNetworksModalActive: isNetworksModalActive =>
  //   set({ isNetworksModalActive }),
  // selectedPool: null,
  // redirectionToPoolMessage: null,
  // tokensMarketCaps: null,
  // setUsdtMarketCaps: usdtMarketCaps => set({ usdtMarketCaps }),
  // setRedirectionToPoolMessage: redirectionToPoolMessage =>
  //   set({ redirectionToPoolMessage }),
  // usdtMarketCaps: {},
  // setTokensMarketCaps: tokensMarketCaps => set({ tokensMarketCaps }),
  // setSelectedPool: selectedPool => set({ selectedPool }),

  // errorMessage: '',
  // setErrorMessage: errorMessage => set({ errorMessage }),
  // allPoolsTokens: null,
  // setAllPoolsTokens: allPoolsTokens => set({ allPoolsTokens }),

  // isShowLowAllPools: getInitialIsShowLowPools(
  //   lowPoolParamKeys.isShowLowAllPools
  // ),
  // setShowLowAllPools: isShowLowAllPools => set({ isShowLowAllPools }),

  // isShowParticipantLowPools: getInitialIsShowLowPools(
  //   lowPoolParamKeys.isShowParticipantLowPools
  // ),
  // setShowParticipantLowPools: isShowParticipantLowPools =>
  //   set({ isShowParticipantLowPools }),

  // isShowCreatorLowPools: getInitialIsShowLowPools(
  //   lowPoolParamKeys.isShowCreatorLowPools
  // ),
  // setShowCreatorLowPools: isShowCreatorLowPools =>
  //   set({ isShowCreatorLowPools }),
}));

export const useAppStore = appStore;
